<template>
  <div class="content impact-content">
    <div class="header px-8 md:px-4 pt-4">
      <div class="row">
        <div class="col-sm-6">
          <h1>Impact Posts</h1>
        </div>
        <div class="col-sm-6 text-right">
          <a v-if="activeCharityInfo"
             :href="`${config.donor_next_scheme}://${activeCharityInfo.subdomain}.${config.donor_next_url}/posts`"
             class="btn btn-sm"
             target="_blank"
             style="padding: 11px 10px;">View All Posts</a>
          <router-link :to="{name: 'impactPostAdd'}"
                       class="btn btn-sm"
                       style="margin-left: 10px;" ><span class="plus-icon"></span>New Post</router-link>
        </div>
      </div>
    </div>
<!--    class="posts-list"-->
    <div class="flex flex-wrap overflow-hidden px-8 md:px-4 pt-4">
      <div class="w-4/5 xl:w-3/4 lg:w-full pr-5 lg:pr-0 posts-list">
        <div class="d-block shadow-md rounded-md bg-white">
          <div class="posts-header">
            <div class="tab-h-wrap">
              <table>
                <thead>
                <tr>
                  <th width="66px">Thumbnail</th>
                  <th width="18%">Title</th>
                  <th width="42%">Body Text</th>
                  <th width="68px">Actions</th>
                </tr>
                </thead>
              </table>
            </div>
          </div>
          <div v-if="postsLoaded" class="posts">
            <div v-if="posts.length<1" class="empty-placeholder">
              <img :src="require('../../assets/paceholders/1.svg')" alt="No results">
              <h3>No Posts Yet</h3>
            </div>
            <table v-else>
              <tbody class="posts-list-table">
              <tr
                  v-for="(post, index) in posts"
                  :key="index"
              >
                <td width="66px">
                  <router-link
                      :to="{name: 'impactPost', params: {postId: post.feedback_id}}"
                      class="post-img"
                  ><img v-if="getPostThumbnail(post)" width="60px" :src="getPostThumbnail(post)"></router-link>
                </td>
                <td width="18%">
                  <h2>
                    <router-link
                        :to="{name: 'impactPost', params: {postId: post.feedback_id}}"
                    >{{post.title}}
                    </router-link>
                    <div class="info">{{post.created_at | dateFormat('MMM DD, YYYY')}}</div>
                  </h2>

                </td>
                <td width="42%">
                  <div class="overview" v-html="post.body"></div>
                </td>
                <td width="68px">
                  <div class="action">
                    <router-link
                        :to="{name: 'impactPostEdit', params: {postId: post.feedback_id}}"
                    ><img :src="require('./edit-icon.svg')" alt="edit"></router-link>
                    <a
                        v-on:click.prevent="activePostId = post.feedback_id;isDeleteModal = true"
                        href="#"
                    ><img :src="require('./cross-icon.svg')" alt="delete"></a></div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="w-1/5 xl:w-1/4 lg:w-full lg:mt-6">
        <div class="d-block shadow-md rounded-md bg-white left-sidebar">
          <div class="faq-list rounded-t-md">
            <div>
              <h3><a href="http://help.harnessapp.com/en/articles/3484784-what-is-an-impact-post" target="_blank"><img
                  :src="require('./messages-icon.svg')" alt="m-i">What is an Impact Post?</a>
              </h3>
              <p class="info">
                An Impact Post is a blog style post that includes an image or video that helps keep your supporters engaged</p>
            </div>
            <div>
              <h3><a href="http://help.harnessapp.com/en/articles/3484786-how-to-create-a-compelling-impact-post"
                     target="_blank">How to create an Impact Post</a>
              </h3>
              <p class="info">
                Learn step-by-step how to create an impact post in your Harness Admin Dashboard and Mobile App</p>
            </div>
          </div>
          <ul class="faq-links">
            <li><a href="http://help.harnessapp.com/en/collections/2016433-impact-posts"
                   target="_blank">Tips & Best Practices for Posts</a>
            </li>
            <li><a
                href="http://help.harnessapp.com/en/articles/3484789-can-an-impact-post-show-a-video"
                target="_blank">Which video/image files can I use?</a>
            </li>
            <li><a href="http://help.harnessapp.com/en/articles/3490767-how-often-should-we-post"
                   target="_blank">How often should we post?</a>
            </li>
            <li><a href="http://help.harnessapp.com/en/collections/2016433-impact-posts"
                   target="_blank" class="visit">Visit FAQ Page</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <modal v-if="isDeleteModal"
           v-on:close-modal="activePostId = null;isDeleteModal = false"
           v-on:delete-post="deleteSelectedPost"
           :modal-name="'delete-impact-post'"></modal>

  </div>
</template>

<script>
  import {getPosts, deletePost} from '@/utils/api';
  import {getYoutubeId, isValidYoutube} from '@/utils/video';
  import Modal from '../Modal/index.vue';
  import config from '../../../public/harness_config.json';
  import {mapState} from "vuex";

  export default {
    name: 'ImpactPosts',
    mounted() {
      this.updatePosts();
    },
    metaInfo: {
      title: 'Impact Posts',
    },
    components: {
      Modal,
    },
    methods: {
      deleteSelectedPost() {
        this.isDeleteModal = false;
        deletePost(this.activePostId).then(() => {
          this.updatePosts();

          this.activePostId = null;
        }).catch(error => {
// eslint-disable-next-line
          console.error('error during deleting the post ' + error);
        });
      },
      updatePosts() {
        getPosts().then(posts => {
          this.posts = posts;
          this.postsLoaded = true;
        });
      },
      getPostThumbnail(post) {
        function checkImg(url) {
          return (url.match(/\.(jpeg|jpg|gif|png)$/) != null);
        }

        if (checkImg(post.url)) {
          return post.url;
        }
        if (post.url.indexOf('wistia.com') > -1 && post.url.indexOf('.bin') > -1) {
          return post.url.replace('.bin', '.jpg?video_still_time=1&image_crop_resized=360x240');
        }
        if (isValidYoutube(post.url)) {
          return `https://img.youtube.com/vi/${getYoutubeId(post.url)}/0.jpg`;
        }

        return '';
      },
    },
    computed: {
      ...mapState({
        activeCharityId: state => state.auth.activeCharityId,
        activeCharityInfo: state => state.charities.activeCharityInfo,
      }),
      config() {
        return config;
      },
    },
    filters: {
      capitalize(value) {
        if (!value) return '';
        value = value.toString();
        return value.charAt(0).toUpperCase() + value.slice(1);
      },
    },
    watch: {
      'activeCharityId'() {

        this.posts = [];
        this.postsLoaded = false;
        this.updatePosts();
      },
    },
    data() {
      return {
        posts: [],
        postsLoaded: false,
        isDeleteModal: false,
        activePostId: null,
      };
    },
  };
</script>

<style scoped lang="scss">
td .info{
  margin-top: 4px;
  font-size: 12px;
  line-height: 1.25;
  color: #677788;
}
</style>
